import React from "react";

import USAID_Logo from "../../../Img/USAID_Logo.png";
import PEPFAR_Logo from "../../../Img/PEPFAR_Logo.jpg";
import SOAR_Logo from "../../../Img/SOAR_Logo.jpg";
import DM_Banner from "../../../Img/DM/banner.jpg";

import * as GBConst from "../../GB/NonComponents/GBConst";
import { getModName } from "../../GB/NonComponents/GBUtil";

import * as Theme from "../../../App/Theme";

class DMWelcomeForm extends React.Component {
    getStyledParagraph = (idStr, headingStr, textStr, marginLeftNum) => {
        try {
            if (typeof marginLeftNum === "undefined") {
                marginLeftNum = 0;
            }

            return (
                <p
                    id={idStr}
                    key={idStr}
                    style={{
                        marginLeft: marginLeftNum,
                    }}
                >
                    <strong
                        key={idStr + "_strong"}
                        style={{
                            color: Theme.HL_PrimaryColor,
                        }}
                    >
                        {headingStr}
                    </strong>

                    {textStr}
                </p>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const styles = {
                start_page: {
                    padding: "10px",
                },

                col: {
                    width: "32%",
                    display: "inline-block",
                },

                indent: 40,
            };

            const text = {
                opening: {
                    p1: "The VMMC DMPPT 2 Online was developed with technical leadership provided by Emmanuel Njeuhmeli (USAID Washington), in collaboration with Project SOAR (Supporting Operational AIDS Research). SOAR is a Cooperative Agreement (AID-OAA-A-14-00060) led by the Population Council and made possible by the generous support of the American people through the President’s Emergency Plan for AIDS Relief (PEPFAR) and the United States Agency for International Development (USAID). This activity was implemented by SOAR partners Avenir Health (Peter Stegman, Michel Tchuenche, Katharine Kripke, Thomas Podkowiak, Robert McKinnon, Matthew Hamilton, and Steven Forsythe) and Palladium (Melissa Schnure, Juan Dent). Avenir Health led the development of the web-based tool. The contents of this toolkit are the sole responsibility of Project SOAR and the Population Council and do not necessarily reflect the views of USAID or the United States Government.",
                    p2: "Project SOAR would like to acknowledge the support of all stakeholders: WHO, UNAIDS, UNICEF, World Bank, BMGF, OGAC, PEPFAR ICPI, PEPFAR MC TWG, CDC, USAID, DoD, AVAC, USG country teams, Ministries of Health in Uganda, Malawi, Tanzania, Swaziland, South Africa, Namibia, Mozambique, Lesotho, Kenya, Zambia and Zimbabwe; and the various VMMC implementing partners.",
                },

                description: {
                    heading: "The " + getModName(GBConst.GB_DM),
                    p1: "The online version of the DMPPT 2 is a monitoring and planning tool that generates coverage estimates and target and impact projections for the VMMC program down to the district level, disaggregated by five-year age group.",
                    p2: "To use the DMPPT 2, the user specifies the target male circumcision coverage level by age group, and the target year by which the coverage should be achieved in the ‘Options’ menu. Various visualizations of the coverage, target, and impact data are available in the ‘Results’ tabs. In addition, a comprehensive dataset for the specified targets can be downloaded in Microsoft Excel-compatible format.",
                },

                options: {
                    p1Heading: "Choose country: ",
                    p1: "Select a country to analyze",
                    p2Heading: "Choose province: ",
                    p2: "Select a province or region to analyze (if applicable)",
                    p3Heading: "Choose SNU: ",
                    p3: "Select a subnational unit (e.g., district, county) to analyze.",
                    p4Heading: "Target year: ",
                    p4: "The year by the beginning of which the VMMC program will reach the user-specified target coverage (detailed in the 'Coverage' section). This means that the program will reach the target coverage by the beginning of this year; i.e., if the user chooses 2020 as the target year, the program will reach its target by the end of 2019. Years displayed are U.S. Government Fiscal Years unless otherwise indicated.",
                    p5Heading: "Coverage: ",
                    p5: " VMMC coverage (%), by age group.",
                    p5_1Heading: "Base: ",
                    p5_1: "The male circumcision prevalence prior to initiation of the VMMC program in the specified country/province/SNU. This is a fixed input that the user cannot change. It is derived from the most recent Demographic and Health Survey or other official survey prior to the start of the VMMC program. In most cases the male circumcision prevalence is not available below the provincial or regional level; if this is the case, the provincial/regional prevalence is used for every SNU in the province/region.",
                    p5_2Heading: "Target: ",
                    p5_2: "The user-specified coverage target, which will be achieved by the target year (see 'Target year' explanation). This coverage will never drop below the base level; therefore, if the user enters a target coverage of 0 in certain age groups, the projection will assume no scale-up in these age groups and will maintain the base level of coverage.",
                    p5_3: "*Modeled MC coverage is a result of both baseline (e.g., traditional) circumcisions, and circumcisions conducted through the VMMC program.",
                    p6Heading: "Download output table: ",
                    p6:
                        "This button allows the user to download an Excel file of all output parameters for the specified country with the user-specified coverage targets. The output table will contain the following data for each SNU: targets by age and year, coverage estimates by age and year, uptake rate," +
                        String.fromCharCode(8224) +
                        " HIV infections averted, VMMC per HIV infections averted.",
                    p6_1a: String.fromCharCode(8224) + " The ",
                    p6_1bBold: "uptake rate",
                    p6_1c: " is the number of circumcisions in a given age group in a given year divided by the number of uncircumcised men in that age group and year.",
                    p7: "To assess different scenarios of coverage by age group or changing the target year, make the changes in the menu above the button, and press the button to download the table.",
                },

                results: {
                    heading: {
                        text: "Results instructions",
                    },
                    intro: {
                        text: "Each result can be displayed graphically, or as a table – the user can specify this with the radio buttons at the bottom of each tab. The user can also specify the timeframe and age range (as applicable) at the bottom of each tab.",
                    },
                    indicators: [
                        {
                            title: "Result 1",
                            text: "The number of VMMCs required by age and year to reach and maintain the user-specified coverage level by the target year. The cross-hatched columns represent VMMCs that have already been conducted by the program (historical VMMCs) and the targets for the current year. The purpose of this graph is for the user to see whether the annual number of target VMMCs is similar to what has been done in the past, or would require many more or fewer circumcisions annually than past achievements. It is a quick visual check for the feasibility of a given set of targets for each SNU.",
                        },
                        {
                            title: "Result 2",
                            text: "Baseline MC prevalence (%) prior to the VMMC program in [year] by age group and SNU compared to modeled MC coverage estimates at the beginning of a user-specified year. When set to the current year, the MC coverage is a result of program achievements through the end of the prior year. When set to future years, the MC coverage is a result of progress toward user-specified coverage targets.",
                        },
                        {
                            title: "Result 3",
                            text: "Male circumcision prevalence (%) by SNU before the start of the VMMC program compared to modeled estimates by a user-specified year, in a user-specified age group. When set to the current year, the MC coverage is a result of program achievements through the end of the prior year. When set to future years, the MC coverage is a result of progress toward user-specified coverage targets.",
                        },
                        {
                            title: "Result 4",
                            text: "Modeled estimates of MC coverage (%) by age group and SNU, for a user-specified year. Color-coding represents level of coverage (key in tab). When set to the current year, the MC coverage is a result of program achievements through the end of the prior year. When set to future years, the MC coverage is a result of progress toward user-specified coverage targets. ",
                        },
                        {
                            title: "Result 5 - Impact",
                            text: "HIV infections averted by SNU, counted over a fifteen-year period starting in 2017. 'Program VMMCs to date' refers to historical VMMCs already conducted by the national program. 'Scale-up VMMCs only' refers to the future VMMCs needed to achieve and maintain the user-specified coverage target.",
                        },
                        {
                            title: "Result 6 - Efficiency",
                            text: "The number of VMMCs required to avert one HIV infection by SNU, over a fifteen-year period starting in 2017. This metric only takes into account the 'scale-up VMMCs' only, i.e., the future VMMCs needed to achieve and maintain the user-specified coverage target.",
                        },
                        {
                            title: "Result 7",
                            text: "[Visualized only when the user selects 'Show global outputs'] Cross-country comparison (comparable to Result 3): Male circumcision prevalence (%) before the start of the VMMC program compared to modeled estimates by a user-specified year, in a user-specified age group. When set to the current year, the MC coverage is a result of program achievements through the end of the prior year. When set to future years, the MC coverage is a result of progress toward user-specified coverage targets.",
                        },
                        {
                            title: "Result 8",
                            text: "[Visualized only when the user selects 'Show global outputs'] Cross-country comparison (comparable to Result 4): Modeled estimates of MC coverage (%) by age group, for a user-specified year. Color-coding represents level of coverage (key in tab). When set to the current year, the MC coverage is a result of program achievements through the end of the prior year. When set to future years, the MC coverage is a result of progress toward user-specified coverage targets.",
                        },
                        {
                            title: "Result 9(a)",
                            text: "Age prioritization analysis 1, Number of circumcisions done by year and age-group. The number of VMMCs already conducted by the national program in each age group and year.",
                        },
                        {
                            title: "Result 9(b)",
                            text: "Age prioritization analysis 2, Uptake rate by year and age group. The uptake rate is the number of circumcisions in a given age group in a given year divided by the number of uncircumcised men in that age group and year (represented as a percentage).",
                        },
                        {
                            title: "Result 9(c)",
                            text: "Age prioritization analysis 3, Increase in coverage. The increase in VMMC coverage, by age group, from one year to the next.",
                        },
                        {
                            title: "Result 9(a,b,c)",
                            text: "Age prioritization analysis. The is a graphical representation of results 9(a), 9(b) and 9(c) shown in one panel.",
                        },
                        {
                            title: "Result 10",
                            text: "[Visualized only when the user selects 'Show global outputs'] Age prioritization analysis, Uptake of VMMC services by country: Cross-country comparison showing the uptake rate or VMMC services.",
                        },
                        {
                            title: "Result 11",
                            text: "Unmet need: uncircumcised male population by age group.  The proportion of the male population that is uncircumcised by age group.",
                        },
                    ],
                },
            };

            const p6NoteStr = (
                <p
                    id={"options.p6_1"}
                    key={"options.p6_1"}
                    style={{
                        marginLeft: styles.indent,
                    }}
                >
                    {text.options.p6_1a}

                    <strong
                        key={"options.p6_1_strong"}
                        style={{
                            color: Theme.HL_PrimaryColor,
                        }}
                    >
                        {text.options.p6_1bBold}
                    </strong>

                    {text.options.p6_1c}
                </p>
            );

            let indicatorsStrArray = [];

            for (let i = 1; i <= text.results.indicators.length; i++) {
                indicatorsStrArray.push(
                    this.getStyledParagraph(
                        "options.results.indicator" + i,
                        text.results.indicators[i - 1].title + ": ",
                        text.results.indicators[i - 1].text
                    )
                );
            }

            return (
                <div style={styles.start_page}>
                    <div style={styles.col}>
                        <img
                            src={USAID_Logo}
                            alt=""
                            style={{ maxHeight: "100px", padding: "0 20px" }}
                        />
                    </div>

                    <div style={styles.col}>
                        <div style={{ width: "200px", margin: "0 auto" }}>
                            <img
                                src={PEPFAR_Logo}
                                alt=""
                                style={{ maxHeight: "100px", padding: "0 20px" }}
                            />
                        </div>
                    </div>

                    <div style={styles.col}>
                        <img
                            src={SOAR_Logo}
                            alt=""
                            style={{ float: "right", maxHeight: "100px", padding: "0 20px" }}
                        />
                    </div>

                    <p id="opening.p1">
                        {text.opening.p1}
                        <a href="http://projsoar.org">projsoar.org</a>
                    </p>
                    {this.getStyledParagraph("opening.p2", null, text.opening.p2)}

                    <div>
                        <img
                            alt="" // avoid hint
                            src={DM_Banner}
                            style={{
                                //float       : 'right',
                                //maxHeight   : '100px',
                                paddingBottom: 20,
                                //paddingLeft : 20,
                                width: "100%",
                            }}
                            title={
                                "Photo captions left to right (photos courtesy of PhotoShare) :\n " +
                                "1. Three boys brought by their mother for male circumcision (MC) to the " +
                                "George Health Centre in Lusaka, Zambia. There is increasing evidence that more people " +
                                "are choosing medical MC under local anesthesia over traditional 'painful' MC.\n " +
                                "2. A group of youths escort a young male on his way to undergo male circumcision, " +
                                "the traditional rite of passage in Western Kenya.\n " +
                                "3. Ayanda, a 14-year-old player from Moroka Lions FC, rides on " +
                                "Grassroot Soccer Coach Dumisani's back after spraining his foot during his team's " +
                                "first match of the day, at the HIV Counseling and Testing (HCT) Tournament in " +
                                "Alexandra Township, South Africa.\n " +
                                "4. A peer counselor conducts HIV/AIDS training for young circumcised boys being " +
                                "initiated into manhood in the Samburu community in northern Kenya.\n " +
                                "5. Students participate in a DramAidE forum theater performance at a high school in " +
                                "Kwazulu Natal, a province in South Africa with the highest HIV/AIDS prevalence.\n " +
                                "6. Jose Rimon of the Health Communication Partnership (HCP) with men at a gathering " +
                                "about HIV/AIDS in India."
                            }
                        />
                    </div>

                    <div id="description.heading">
                        <h2>
                            <strong>{text.description.heading}</strong>
                        </h2>
                    </div>
                    {this.getStyledParagraph("description.p1", null, text.description.p1)}
                    {this.getStyledParagraph("description.p2", null, text.description.p2)}
                    {this.getStyledParagraph("options.p1", text.options.p1Heading, text.options.p1)}
                    {this.getStyledParagraph("options.p2", text.options.p2Heading, text.options.p2)}
                    {this.getStyledParagraph("options.p3", text.options.p3Heading, text.options.p3)}
                    {this.getStyledParagraph("options.p4", text.options.p4Heading, text.options.p4)}
                    {this.getStyledParagraph("options.p5", text.options.p5Heading, text.options.p5)}
                    {this.getStyledParagraph(
                        "options.p5_1",
                        text.options.p5_1Heading,
                        text.options.p5_1,
                        styles.indent
                    )}
                    {this.getStyledParagraph(
                        "options.p5_2",
                        text.options.p5_2Heading,
                        text.options.p5_2,
                        styles.indent
                    )}
                    {this.getStyledParagraph("options.p5_3", null, text.options.p5_3, styles.indent)}
                    {this.getStyledParagraph("options.p6", text.options.p6Heading, text.options.p6)}
                    {p6NoteStr}
                    <p id="options.p7">{text.options.p7}</p>

                    <div id="results.heading.text">
                        <h2>
                            <strong>{text.results.heading.text}</strong>
                        </h2>
                    </div>
                    {this.getStyledParagraph("results.intro.text", null, text.results.intro.text)}
                    {indicatorsStrArray}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMWelcomeFormDiv"}
                    key={"DMWelcomeFormDiv"}
                >
                    <h3 key={"DMWelcomeFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMWelcomeForm;
